export enum BookingInvoiceType {
  SickPay = "SickPay",
  OrderCreated = "OrderCreated",
  Introduction = "Introduction",
  Completion = "Completion",
  Other = "Other"
}

type BookingInvoiceSpecialCode = "333333" | "666666" | "777777" | "888888" | "999999";

export const bookingInvoiceSpecialCodes: Record<
  BookingInvoiceSpecialCode,
  BookingInvoiceType
> = {
  "333333": BookingInvoiceType.OrderCreated,
  "666666": BookingInvoiceType.Introduction,
  "777777": BookingInvoiceType.Completion,
  "888888": BookingInvoiceType.Other,
  "999999": BookingInvoiceType.SickPay
};
